import styles from './Hero.module.scss';
import { Image } from '@sitecore-jss/sitecore-jss-react';
import { useMediaQuery } from 'usehooks-ts';

export default function Hero({ hero }) {
  const isMobile = useMediaQuery('(max-width: 480px)');

  return (
    <div className={styles.wrapper}>
      <Image
        field={isMobile ? hero.mobileImage : hero.image}
        className={styles.backgroundImage}
      ></Image>
      <div className={styles.content}>
        {/* <h3 className={styles.subtitle}>{hero.subtitle.value}</h3> */}
        <h1 className={styles.title}>{hero.title.value}</h1>
        <p className={styles.text}>{hero.date.value}</p>
      </div>
    </div>
  );
}
